import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

interface SeverityBadgeProps {
  level: 'high' | 'medium' | 'low';
  className?: string;
}

export const SeverityBadge = ({ level, className }: SeverityBadgeProps) => {
  const getVariant = () => {
    switch (level) {
      case 'high':
        return 'destructive';
      case 'medium':
        return 'default';
      case 'low':
        return 'secondary';
    }
  };

  const getLabel = () => {
    switch (level) {
      case 'high':
        return 'Risque élevé';
      case 'medium':
        return 'Risque modéré';
      case 'low':
        return 'Risque faible';
    }
  };

  return (
    <Badge 
      variant={getVariant()}
      className={cn(
        "text-xs font-medium",
        level === 'medium' && "bg-warning text-warning-foreground",
        className
      )}
      aria-label={getLabel()}
    >
      {getLabel()}
    </Badge>
  );
};
